<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('推荐系统.推荐系统')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="rounded-20 p-30" style="background-color: #280A00;">
					<div class="flex items-center justify-between">
						<span class="text-28 text-white">{{$t('推荐系统.我的团队')}}</span>
						<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#9646FF; background-color: #9646FF20;">
							<span class="text-20" style="color: #9646FF;">{{lp_vip_name}}</span>
						</div>
					</div>
					<div class="flex items-center justify-between mt-30">
						<div class="flex-1">
							<div class="">
								<span class="text-24 text-#999">{{$t('推荐系统.直推人数')}}</span>
							</div>
							<div class="mt-10">
								<span class="text-60 text-white font-bold">{{direct_list_number}}</span>
							</div>
						</div>
						<div class="flex-1">
							<div class="">
								<span class="text-24 text-#999">{{$t('推荐系统.团队总人数')}}</span>
							</div>
							<div class="mt-10">
								<span class="text-60 text-white font-bold">{{lp_team}}</span>
							</div>
						</div>
					</div>
					<div class="mt-30 rounded-20 flex items-center justify-between p-30" style="background-color: #441201;">
						<div class="flex-1">
							<div>
								<span class="text-20 text-#ccc">{{$t('推荐系统.累计收益')}}</span>
							</div>
							<div class="mt-10">
								<span class="text-44 text-primary font-bold">{{team_bouns}} ROON</span>
							</div>
						</div>
						<img class="w-90 h-90" src="@/assets/images/pages/recommender-system/sy.png" alt="" />
					</div>
				</div>
<!--				<div class="mt-30 bg-white/10 rounded-20 p-30">-->
<!--					<div class="rounded-20 flex items-center justify-between">-->
<!--						<div class="flex-1">-->
<!--							<div>-->
<!--								<span class="text-20 text-#ccc">USDR余额</span>-->
<!--							</div>-->
<!--							<div class="mt-10">-->
<!--								<span class="text-44 text-white font-bold">25  USDR</span>-->
<!--							</div>-->
<!--						</div>-->
<!--						<img class="w-90 h-90" src="@/assets/images/pages/recommender-system/sy.png" alt="" />-->
<!--					</div>-->
<!--					<div @click="showAmountPopup = true" class="mt-30 bg-primary h-100 flex justify-center bg-primary items-center rounded-full">-->
<!--						<span class="text-32 text-white">提现</span>-->
<!--					</div>-->
<!--				</div>-->

<!--                <div class="mt-30 bg-white/10 rounded-20 p-30">-->
<!--                    <div class="rounded-20 flex items-center justify-between">-->
<!--                        <div class="flex-1">-->
<!--                            <div>-->
<!--                                <span class="text-20 text-#ccc">ROON余额</span>-->
<!--                            </div>-->
<!--                            <div class="mt-10">-->
<!--                                <span class="text-44 text-white font-bold">25  ROON</span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <img class="w-90 h-90" src="@/assets/images/pages/recommender-system/sy.png" alt="" />-->
<!--                    </div>-->
<!--                    <div @click="showAmountPopup = true" class="mt-30 bg-primary h-100 flex justify-center bg-primary items-center rounded-full">-->
<!--                        <span class="text-32 text-white">提现</span>-->
<!--                    </div>-->
<!--                </div>-->


				<div class="mt-30 bg-white/10 rounded-20 p-30">
					<div>
						<span class="text-28 text-white">{{$t('推荐系统.我的推荐链接')}}</span>
					</div>
					<div class="rounded-50 mt-30" style="background-color: #3E1303;">
						<div class="py-30 text-center px-40 flex items-center justify-center">
							<span class="text-26 text-center text-primary break-all">{{share_url}}</span>
						</div>
						<div class="mt-30 bg-primary h-100 flex justify-center bg-primary items-center rounded-full" @click="onCopy(share_url)">
							<span class="text-32 text-white">{{$t('推荐系统.复制')}}</span>
						</div>
					</div>
					<div class="mt-30" v-if="parent_address != ''">
						<span class="text-24 text-#999">{{$t('推荐系统.上级地址')}}：{{parent_address}}</span>
					</div>

                    <div class="mt-30">
                        <span class="text-24 text-#999">{{$t('推荐系统.分享链接给好友，好友添加LP后您将获得其收益的10%作为推荐奖')}}</span>
                    </div>
				</div>
				<div class="mt-30 bg-white/10 rounded-20 p-30">
					<div>
						<span class="text-28 text-white">{{$t('推荐系统.当前等级权益')}}</span>
					</div>
					<div class="rounded-20 mt-30 flex items-center justify-between p-30" style="background-color: #3C3106;">
						<div class="w-88 h-88 rounded-20 flex items-center justify-center"
						 style="background-image: linear-gradient(to bottom, #FF9A41, #FF8316);">
						 <span class="text-white text-36">{{lp_vip_name}}</span>
						 </div>
						 <div class="ml-30 flex-1">
							 <div>
								 <span class="text-white text-32">{{direct_number}}{{$t('推荐系统.个直推')}}</span>
							 </div>
							 <div class="mt-10">
								 <span class="text-24 text-#ccc">{{$t('推荐系统.推荐奖励')}}</span>
								 <span class="text-24 text-primary">{{lp_vip_team_bouns}}%</span>
							 </div>
						 </div>
						 <div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
						 	style="border-color:#FF993E; background-color: #FF993E20;">
						 	<span class="text-20" style="color: #FF993E;">{{$t('推荐系统.当前等级')}}</span>
						 </div>
					</div>

				</div>

				<div class="mt-30 bg-white/10 rounded-20 p-30">
					<div class="mb-30">
						<span class="text-28 text-white">{{$t('推荐系统.直推列表')}}</span>
					</div>
					<div v-for="(item, index) in direct_list" :key="index" class="mb-30 bg-white/10 p-30 rounded-20">
						<div>
							<span class="text-28 text-white font-bold">{{item.user.show_address}}</span>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<span class="text-24" style="color: #A81CF3;">LP:{{item.lp_token}}</span>
							<span class="text-26 font-bold text-primary">{{item.token_amount}} USDR</span>
						</div>
						<div class="flex items-center justify-between">
							<span class="text-22 text-#ccc">{{item.start_date}}</span>
							<span class="text-26 text-#999">{{item.roon_amount}} ROON</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="flex items-center justify-center relative h-200">
						<img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png"
							alt="" />
					</div>
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("推荐系统.领取成功")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("推荐系统.已成功领取")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-50 font-bold text-primary">25ROON</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("推荐系统.收益已发送到您的钱包地址")}}</span>
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
							</div>
						</div>
					</div>
				</div>

			</van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
				node_allocate: 0,
				node_release: 0,
				node_low_pool: 1995,
				node_day: 0,
				node_number: 0,
                lp_vip_team_bouns: 0,
				node_price: 0,
				node_progress: 0,
				node_surplus_number: 0,
                direct_list_number: 0,
				last_pledge_time: "",
                parent_address: "",
                share_url: "",
				roon_number: "100000",
				node_name: "",
				rgt_swap: "",
				mining_contract: "",
                lp_vip_name: "R0",
				last_pledge_name: "",
				address: "",
				total_address: "",
				show_address: "",
				order_id: "",
				users_id: "",
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
				web3Provider: null,
				web3: null,
				list: [],
                direct: [],
                direct_list: [],
                direct_number: 0,
                team_bouns: 0,
                lp_team: 0,
				showAmountPopup: false,
				// 支付进行中的不可关闭 loading 遮罩
				paying: false,
				canGo: true,
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: 100
					},
					{
						id: 2,
						num: 500
					},
					{
						id: 3,
						num: 1000
					},
					{
						id: 4,
						num: 2000
					},
					{
						id: 5,
						num: 5000
					},

				]
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);
			}
			vm.getList();
		},
		methods: {
            onCopy(txt) {
                utils.copy(txt)
            },
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
			getList() {
				let vm = this
				getShowAddress()
				ajaxData("/lp/team").then(res => {
					console.log(res)
					vm.lp_vip_name = res.data.lp_vip_name;
					vm.direct_list = res.data.direct_list;
					vm.direct_list_number = res.data.direct_list_number;
					vm.lp_team = res.data.lp_team;
					vm.team_bouns = res.data.team_bouns;
					vm.share_url = res.data.share_url;
					vm.lp_vip_team_bouns = res.data.lp_vip_team_bouns;
					vm.parent_address = res.data.parent_address;

                    vm.direct_number = res.data.direct_number;
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			handleInputTwo() {
				const vm = this;
				let val = String(vm.form?.amount ?? '');
				// 仅保留数字（不允许小数点与其他字符）
				val = val.replace(/\D/g, '');
				// 解析后的数值可能出现 NaN 的情况，需回退
				const parsed = parseInt(val, 10);
				if (!val.length || Number.isNaN(parsed) || !Number.isFinite(parsed)) {
					vm.form.amount = '';
					vm.form.dd_roon = 0;
					return;
				}
				vm.form.amount = parsed;
				vm.form.dd_roon = parsed / 20;
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.swap-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/swap/img_banner.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item2-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item3-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.bg-\#5ACC3C {
		background-color: #5ACC3C;
	}
</style>
